module.exports = __webpack_public_path__ + "static/media/POLISHING.0e31cdbf.png";